<template>
  <section id="hero">
   <!-- <v-img
      :min-height="minHeight"
      :src="require('@/assets/compac/compac-home.jpg')"
      class="white--text"
      gradient="to bottom, rgba(11, 28, 61, .9), rgba(0,0,0,.4)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center mx-auto"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-subheading
            weight="regular"
            title="WE LOVE MAKING THINGS SIMPLE AND AMAZING"
          />
          <base-heading
            size="text-h2"
            title="WELCOME TO ZERO"
            weight="medium"
          />
          <base-body>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae nobis neque aspernatur in quas iure id aliquid, esse debitis, quibusdam mollitia! Quia ea expedita magnam totam, earum omnis et perspiciatis?
          </base-body>
          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn>
              Discover More
            </base-btn>
            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>
            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>       :src="require('@/assets/compac/home-compac.png')"
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/compac/home-compac.png')"
      class="white--text"
      gradient="to bottom, rgba(11, 28, 61, .1), rgba(0,0,0,.1)"
    >

    -->
    <v-img

      width="auto"

      :src="require('@/assets/compac/home-compac_reducida2.png')"
      class="white--text"
      gradient="to bottom, rgba(11, 28, 61, .1), rgba(0,0,0,.1)"
    >

      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center mx-auto"
          height="100%"
          max-width="700"
          width="100%"
        >
         <!-- <base-subheading
            weight="regular"
            title="WE LOVE MAKING THINGS SIMPLE AND AMAZING"
          />

          <base-heading
            size="text-h2"
            title="Bienvenidos a COMPAC"
            weight="medium"
          />-->
          <!--<base-body>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae nobis neque aspernatur in quas iure id aliquid, esse debitis, quibusdam mollitia! Quia ea expedita magnam totam, earum omnis et perspiciatis?
          </base-body>-->
         <!-- <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn>
              Discover More
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
          </div>-->
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>
<script>
  export default {
    name: 'SectionHero',
    provide: {
      theme: { isDark: true },
    },
    metaInfo () {
      return {
        changed: meta => (this.title = meta.titleChunk.toUpperCase()),
      }
    },
    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'
        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>
